import { capitalizeFirstLetter, hasStringKey } from "@/utils/misc";
import { ProducerDto } from "generated";
import { getOptions, getProducerType, getTooltipText } from "./utils";
import Label from "@ingka/label";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { CustomSelect } from "@/components/CustomSelect/CustomSelect";
import { useMetadataFields } from "@/components/MetadataFields/hooks";

type Props = {
  options: ProducerDto[];
  disabled: boolean;
};

const MarketTeamAgency = ({ options, disabled }: Props) => {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const error = getValidationError("producerId", activeAsset.id!);

  const producedBy = activeAsset.producedBy;
  const producerType = getProducerType(producedBy);

  const labelText =
    capitalizeFirstLetter(producerType) || "Markets / Team / Agency";

  const isUpdating =
    isMetadataUpdating(activeAsset.id!, "producedBy") ||
    isMetadataUpdating(activeAsset.id!, "producerId");

  const selectedValue = options.find(
    (item) => item.id === activeAsset.producerId,
  ) || { id: "", name: "" };

  return (
    <>
      <Label
        htmlFor="marketTeamAgency"
        label={
          <LabelWithToolTip
            labelText={labelText}
            toolTipText={getTooltipText(producerType)}
          />
        }
      />
      <CustomSelect
        id="marketTeamAgency"
        disabled={disabled || isUpdating}
        errorMessage={error ? `${labelText} is required` : ""}
        value={{ label: selectedValue.name, value: selectedValue.id }}
        options={getOptions(options, producedBy)}
        onChange={(option) => {
          if (hasStringKey("value", option)) {
            updateMetadata({
              producerId: +option.value,
            });
          }
        }}
      />
    </>
  );
};

export default MarketTeamAgency;
